'use strict';

var index = require('./numbers/index.cjs');

const int = {
    ...index.number,
    transform: Math.round,
};

exports.int = int;
//# sourceMappingURL=int.cjs.map
